import * as React from "react";

import MainLeft from "./MainLeft";
import SettingLeft from "./SettingLeft";

import { usePage } from "@/component/PageControl";

const LeftMenu: React.FC = () => {
  const page = usePage();
  const { pagetype } = page;

  if (pagetype === "setting") return <SettingLeft />;
  if (pagetype === "main") return <MainLeft />;
  return <></>;
};

export default LeftMenu;
